import { render, staticRenderFns } from "./new-edit.vue?vue&type=template&id=251870e8&scoped=true"
import script from "./new-edit.vue?vue&type=script&lang=js"
export * from "./new-edit.vue?vue&type=script&lang=js"
import style0 from "./new-edit.vue?vue&type=style&index=0&id=251870e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251870e8",
  null
  
)

export default component.exports